import React, { useEffect, useState } from 'react';
import { BiTransfer } from 'react-icons/bi';
import { useNavigate, useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import { Company } from '../../../model/company/Company';
import { ErrorToast, SuccessToast } from '../../../utils/toasters';
import { CompanyService } from '../../company/CompanyService';
import { CampaignsService } from '../CampaignsService';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';

const CampaignTransfer = () => {
    const navigate = useNavigate();
    const {
        state: { campaign, companyName },
    }: any = useLocation();

    const { id } = useParams<any>();
    const [companies, setCompanies] = useState<Company[]>([]);
    const [searchText, setSearchText] = useState('');
    const [selectedCompany, setSelectedCompany] = useState<Company>();
    const [filterParams, setFilterParams] = useState({
        page: 1,
        perPage: 10,
        displayName: '',
    });

    const changeFilterHandler = (value: string) => {
        setSearchText(value);
        setFilterParams(prev => ({ ...prev, displayName: value }));
    };

    const submitHandler = async () => {
        await CampaignsService.transferCampaign(Number(id), Number(selectedCompany?.id))
            .then(response => {
                if (response === '') {
                    navigate(-1);
                    SuccessToast(`You have successfully changed company for campaign ID: ${id}`);
                }
            })
            .catch(err => ErrorToast(err));
    };

    useEffect(() => {
        CompanyService.getCompanies(filterParams)
            .then(data => {
                setCompanies(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [filterParams]);

    return (
        <div className="row">
            <div className="col-12">
                <h3>{campaign.title}</h3>
            </div>
            <div className="col-md">
                <div className="card">
                    <div className="card-body">
                        <div className="form-group">
                            <label htmlFor="fromCampaign">Current Company</label>
                            <select className="form-control" disabled>
                                <option selected>{companyName ?? '-'}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-1 d-flex align-items-center justify-content-center flex-column">
                <BiTransfer size={30} />
            </div>
            <div className="col-md">
                <div className="card">
                    <div className="card-body">
                        <div className="form-group">
                            <label className="form-label" htmlFor="fromCampaign">
                                Select new Company
                            </label>
                            <div className="autocomplete-input zindex-5 position-relative">
                                <AutocompleteInput
                                    items={companies}
                                    value={searchText}
                                    renderItems={['id', 'displayName']}
                                    setFilter={changeFilterHandler}
                                    onSelect={company => {
                                        setSelectedCompany(company);
                                        setSearchText(company.displayName);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 mt-3 d-flex justify-content-end">
                <button className="btn btn-outline-primary mr-2" onClick={() => navigate(-1)}>
                    Cancel
                </button>
                <button className="btn btn-primary" disabled={!selectedCompany?.id} onClick={submitHandler}>
                    Update
                </button>
            </div>
        </div>
    );
};

export default CampaignTransfer;
